import React from 'react';
import PropTypes from 'prop-types';
import { DotMark16 } from '@carbon/icons-react';
import './Label.scss';
import { FormattedMessage } from 'react-intl';

const Label = ({ text, i, scaledText, handleClickScene }) => {
  return (
    <div className={`label ${i === 4 ? 'vertical' : ''}`} id={`label-${i}`}>
      <button
        className="expressive-heading-03 white"
        onClick={() => handleClickScene(i)}>
        <DotMark16 className="gray-50" />
        <FormattedMessage id={`Content.scene.${i}.title`} defaultMessage={text}>
          {(txt) => (
            <div className="label-text" style={scaledText}>
              {txt}
            </div>
          )}
        </FormattedMessage>
      </button>
      <div className="line" />
    </div>
  );
};

Label.propTypes = {
  text: PropTypes.string,
  i: PropTypes.number,
  scaledText: PropTypes.object,
  handleClickScene: PropTypes.func,
};

export default Label;
